import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Model, WhenModel } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'

export default function UserProfileSmartview ({ id }) {
  const header = (
    <UI.EmployeeInfo
      width=''
      large
      avatar={<Displays.Image name='avatar_url' />}
      title={<Displays.Text name='name' />}
      text={<Displays.Text name='employment_name' />}
      badges={<Displays.Badges big />}
    />
  )

  return (
    <Model resourceName='users.users' id={id}>
      <Smartview header={header}>
        <WhenModel>
          <SmartviewTextGroup>
            <SmartviewText label={<Translation name='fields.phone.label' />}>
              <Displays.Phone name='phone' />
            </SmartviewText>
            <SmartviewText label={<Translation name='fields.email.label' />}>
              <Displays.Email name='email' />
            </SmartviewText>
          </SmartviewTextGroup>
        </WhenModel>
      </Smartview>
    </Model>
  )
}
